import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TransflectionFiberProbes = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrdLibrary%2F13.png?alt=media&token=5f1bca6e-5865-4119-9c45-31f8ede2ac76',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrdLibrary%2F13.png?alt=media&token=5f1bca6e-5865-4119-9c45-31f8ede2ac76'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/">R & D</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Transflection Fiber Probes</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Transflection Fiber Probes</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Sapphire optics. On-line transmission spectroscopy at long distance in wide range of liquids (from transparent to poorly transparent) High throughput in any part of UV - Vis or Vis - NIR spectra.Flexible and robust for industrial applications in harsh environment. Compatible with all spectrometers. Sapphire windows and a number of removable heads with variable optical path length allows to use transflection probe in wide range of liquids and concentrations. Transflection Dual Pass fiber optic probes are compatible with process-interfaces to ensure the cleaning and reaction monitoring in lab, pilot plant and industrial setup to run full automated process control.

                                    <br /><br />
                                    <a
                                        href="mailto:[EMAIL_ADDRESS]?subject=Inquiry about Transflection Fiber Probes"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
        </Layout>
    )
}

export default TransflectionFiberProbes